import { cloneDeep } from 'lodash/fp'
import name from './name'

export function getConnectionState (state, platform) {
  if (state[name][platform]) {
    return cloneDeep(state[name][platform])
  } else {
    return new Error('No sockets are up. Have you attempted to connect?')
  }
}

/**
 * Retrieves the config options provided by the connectivity plugin.
 * @method getConnectivityConfig
 * @return {Object}
 */
export function getConnectivityConfig (state) {
  return state.config[name]
}

/**
 * Retrieves the pingInterval property from state
 * @method getPingInterval
 * @param {Object} state Redux state.
 * @return {Object}
 */
export function getPingInterval (state) {
  return state[name].pingInterval
}

/**
 * Retrieves the checkConnectivity property from state
 * @method getCheckConnectivity
 * @param {Object} state Redux state.
 * @return {Object}
 */
export function getCheckConnectivity (state) {
  return state[name].checkConnectivity
}
